/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TunnelHTTPProgress = {
  /**
   * Open HTTP response bodies at the last sample; long-lived SSE may be expected
   */
  openResponses: number;
  /**
   * Requests awaiting final HTTP response headers at the last sample
   */
  waitingHeaders: number;
};

/** @internal */
export const TunnelHTTPProgress$inboundSchema: z.ZodMiniType<
  TunnelHTTPProgress,
  unknown
> = z.pipe(
  z.object({
    open_responses: z.int(),
    waiting_headers: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "open_responses": "openResponses",
      "waiting_headers": "waitingHeaders",
    });
  }),
);

export function tunnelHTTPProgressFromJSON(
  jsonString: string,
): SafeParseResult<TunnelHTTPProgress, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TunnelHTTPProgress$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TunnelHTTPProgress' from JSON`,
  );
}
